// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Hg","summaryPar":"Ig","ratingCategories":"Jg","reviewerInfo":"Kg","reviewTypes":"Lg","expanded":"Mg"};